export default () => ({
  componentName: 'cell-copy',
});
